import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=16a0f5a1"
import script from "./Metric.vue?vue&type=script&lang=js"
export * from "./Metric.vue?vue&type=script&lang=js"
import style0 from "./Metric.vue?vue&type=style&index=0&id=16a0f5a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports